import { tss } from "tss-react/mui";
import { DEFAULT_LEFT_PADDING, DEFAULT_RIGHT_PADDING, MOBILE_LEFT_PADDING, MOBILE_RIGHT_PADDING, WINDOW_MAX_WIDTH } from "../../../layout/Layout.styles";

export const useStyles = tss.create(({ theme }) => ({
	root: {
	},
	container: {
		margin: '0 auto',
		maxWidth: WINDOW_MAX_WIDTH,
		paddingLeft: DEFAULT_LEFT_PADDING,
		paddingRight: DEFAULT_RIGHT_PADDING,
		paddingBottom: 24,
		paddingTop: 16,
		overflow: 'hidden',
		[theme.breakpoints.down('md')]: {
			paddingLeft: MOBILE_LEFT_PADDING,
			paddingRight: MOBILE_RIGHT_PADDING,
			paddingBottom: 12,
			paddingTop: 12,
		}
	},
	title: {
		color: '#8892A0',
		fontSize: 16,
		fontWeight: 400,
		lineHeight: '19px',
		margin: '16px 0px'
	},
	border: {
		display: 'block',
		backgroundColor: '#8892A0',
		height: 1,
		width: 50,
	},
}))